module.exports = __webpack_public_path__ + "static/media/Churroschinos.f95fa91d.jpg";